import { forwardRef } from "react";
import type { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export type InputSize = "sm" | "md";

export interface InputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "size"
> {
  error?: boolean;
  className?: string;
  size?: InputSize;
}

const sizeStyles: Record<InputSize, string> = {
  sm: "p-[12px] text-[12px] leading-none font-medium",
  md: "px-4 py-4 text-[13px]",
};

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { error, className, size = "md", ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      {...props}
      className={twMerge(
        "w-full rounded-lg border transition-colors duration-150 outline-none",
        sizeStyles[size],
        "placeholder:text-content-primary/50",
        "focus:border-brand-blue",
        error && "border-destructive-base focus:border-destructive-base",
        className,
      )}
    />
  );
});
